import BackButton from "./BackButton";

export default function ({ title, children }) {
    return (<div className="col-12 searchParent">
        <div className="mainTitle" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <h5 style={{ flexGrow: 2 }}><BackButton /> {title}</h5>
            <div>
                {children}
            </div>
        </div>
    </div>)
}